import React from 'react';
import '../template-file-css/document-file-template.css';


export const SSS_TreatmentPlanReview = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SSS_TreatmentPlanReview' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'> Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Age </span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>  <input type='text' id='txtClientName' name='txtClientName' className='add-only' />  </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' />  </td>
                        <td className='w-100'>  <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Recurring Problem(s)</span>
                    <span className='small'>( Ex: Depression, Poor Academics Poor Peer Relationships, etc.)</span>
                    <textarea id='txtRecurringProblems' name='txtRecurringProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recurring Symptom(s)</span>
                    <span className='small'>(Ex: Restless, Fighting, Difficulty Coping, etc. )</span>
                    <textarea id='txtRecurringSymptoms' name='txtRecurringSymptoms' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Disruptive Behaviors over the past 3-6 months</span>
                    <span className='small'>(Ex: Stealing, Suspensions, Probation, etc.)</span>
                    <textarea id='txtDisruptiveBehaviorsOver' name='txtDisruptiveBehaviorsOver' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Current Medication(s)</b>
                    <span className='eleHeader'>Is client compliant with taking med(s):</span>

                    <input type='radio' id='rbIsClientCompliant_Yes' name='rbIsClientCompliant' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsClientCompliant_No' name='rbIsClientCompliant' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Name of Medication</span></td>
                        <td className='w-150'><span className='eleHeader'>Dose</span></td>
                        <td className='w-400'><span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtNameOfMedication_1" name="txtNameOfMedication_1" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtNameOfMedication_2" name="txtNameOfMedication_2" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtNameOfMedication_3" name="txtNameOfMedication_3" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDose_3" name="txtDose_3" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtNameOfMedication_4" name="txtNameOfMedication_4" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDose_4" name="txtDose_4" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtNameOfMedication_5" name="txtNameOfMedication_5" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDose_5" name="txtDose_5" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtFrequency_5" name="txtFrequency_5" className='add-only' /></td>
                    </tr>
                </table>
                <table>


                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What has worked for the client?</span>
                            <span className='small'>(Indicate which therapeutic approaches have been most effective)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCognitiveBehavioral" id="chkCognitiveBehavioral" className='add-only' value="CognitiveBehavioral" /> Cognitive Behavioral
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSolutionFocused" id="chkSolutionFocused" className='add-only' value="SolutionFocused" /> Solution Focused
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkResourcesUsingWorkbooks" id="chkResourcesUsingWorkbooks" className='add-only' value="ResourcesUsingWorkbooks" /> Resources using Workbooks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPlayTherapy" id="chkPlayTherapy" className='add-only' value="PlayTherapy" /> Play Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPersonCentered" id="chkPersonCentered" className='add-only' value="PersonCentered" /> Person Centered
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkGuidedImagery" id="chkGuidedImagery" className='add-only' value="GuidedImagery" /> Guided Imagery
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherClient' name='cbOtherClient' className='add-only' value='OtherClient' /> Other(s)
                            &nbsp;
                            <input type='text' id='txtOtherClient' name='txtOtherClient' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What progress has the client shown? </span>
                            <span className='small'>(What has the client demonstrated)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbClientShown_None' name='rbClientShown' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbClientShown_Minimal' name='rbClientShown' className='add-only' value='Minimal' /> Minimal
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbClientShown_Moderate' name='rbClientShown' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbClientShown_Varying' name='rbClientShown' className='add-only' value='Varying' /> Varying
                        </td>

                    </tr>
                </table>
                <p className='w-750'>
                    as evidenced by:
                    <textarea id='txtEvidenced_1' name='txtEvidenced_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What has not worked for the client ?</span>
                    <span className='small'>(Clearly indicate what has been the barriers to treatment, if any)</span>
                    <textarea id='txtWorkedForTheClient' name='txtWorkedForTheClient' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Does client, parent/guardian or MHP/S request a treatment goal addition to be considered?</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='radio' id='rbDoesClientParent_Yes' name='rbDoesClientParent' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDoesClientParent_No' name='rbDoesClientParent' className='add-only' value='No' /> No
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            If yes, please list here and state RATIONALE for the recommendation
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Goal:</span>
                    <textarea id='txtGoal' name='txtGoal' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Rationale:</span>
                    <textarea id='txtRationale' name='txtRationale' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the client's overall Engagement / Participation Level with therapy</span>
                    <input type='radio' id='rbClientsOverallEngagement_None' name='rbClientsOverallEngagement' className='add-only' value='None' /> None &nbsp;&nbsp;
                    <input type='radio' id='rbClientsOverallEngagement_Minimal' name='rbClientsOverallEngagement' className='add-only' value='Minimal' /> Minimal &nbsp;&nbsp;
                    <input type='radio' id='rbClientsOverallEngagement_Active' name='rbClientsOverallEngagement' className='add-only' value='Active' /> Active &nbsp;&nbsp;
                    <br />If NONE or MINIMAL, state Why:
                    <textarea id='txtClientsOverallEngagementLevel' name='txtClientsOverallEngagementLevel' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>HOMICIDAL/SUICIDAL ASSESSMENT</span>
                    Is the client currently:
                </p>
                <table>
                    <tr>
                        <td className='w-375'><b>Homicidal</b>
                        </td>
                        <td className='w-375'><b>Suicidal</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHomicidal_Yes' name='rbHomicidal' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbHomicidal_No' name='rbHomicidal' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbSuicidal_Yes' name='rbSuicidal' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbSuicidal_No' name='rbSuicidal' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>PHYSICAL or SEXUAL ABUSE ASSESSMENT</span>
                    Is there any current physical or sexual abuse:&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbPhysicalOrSexualAbuse_Yes' name='rbPhysicalOrSexualAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPhysicalOrSexualAbuse_No' name='rbPhysicalOrSexualAbuse' className='add-only' value='No' /> No &nbsp;&nbsp;&nbsp;
                </p>
                <h3>In the last 30 days has the client:</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Had problems with sleeping?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Had problems caused by alcohol or drugs?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbProblemWithSleeping_Yes' name='rbProblemWithSleeping' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbProblemWithSleeping_No' name='rbProblemWithSleeping' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbCausedByAlcoholOrDrug_Yes' name='rbCausedByAlcoholOrDrug' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbCausedByAlcoholOrDrug_No' name='rbCausedByAlcoholOrDrug' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Had problems with feeling sad?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Gotten in trouble with the law?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbProblemWithFellingSad_Yes' name='rbProblemWithFellingSad' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbProblemWithFellingSad_No' name='rbProblemWithFellingSad' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbGottenTroubleLaw_Yes' name='rbGottenTroubleLaw' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbGottenTroubleLaw_No' name='rbGottenTroubleLaw' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Had problems with fear or anxiety?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Had trouble getting along with other people?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbProblemWithFearAnxiety_Yes' name='rbProblemWithFearAnxiety' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbProblemWithFearAnxiety_No' name='rbProblemWithFearAnxiety' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbTroubleAlongOtherPeople_Yes' name='rbTroubleAlongOtherPeople' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbTroubleAlongOtherPeople_No' name='rbTroubleAlongOtherPeople' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Participated in enjoyable activities?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbParticipatedInEnjoyable_Yes' name='rbParticipatedInEnjoyable' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbParticipatedInEnjoyable_No' name='rbParticipatedInEnjoyable' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>From</span>
                            <input type='text' id="txtFrom" name="txtFrom" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>To:</span>
                            <input type='text' id="txtTo" name="txtTo" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>SIGNATURE PAGE</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sims Social Services Staff</span>
                            <span className='small'>Check all that apply</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkSimsSocialServices_1" id="chkSimsSocialServices_1" className='add-only' value="SimsSocialServices_1" /> The treatment team certifies that it met face-to -face with the client and/or caregiver or legal guardian
                            to collaboratively identify services.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkSimsSocialServices_2" id="chkSimsSocialServices_2" className='add-only' value="SimsSocialServices_2" /> The treatment team certifies that the services outlined in this Treatment Plan are based on an initial
                            and ongoing assessment and further certifies that the services outlined in this Treatment Plan are
                            medically necessary, appropriate, and comprehensive in approach, as well as, consistent with the client's
                            ISC Plan, FINS Plan, and/or other interagency plan, if any such plan[s) exist.

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkSimsSocialServices_3" id="chkSimsSocialServices_3" className='add-only' value="SimsSocialServices_3" /> The treatment team's professional opinion is that the client is ready to engage in the services outlined
                            in this Treatment PIan and it is reasonable to expect a rehabilitative outcome.

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client/Guardian</span>
                            <span className='small'>Check all that apply</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkClientGuardian_1" id="chkClientGuardian_1" className='add-only' value="ClientGuardian_1" /> I participated face-to-face with a member of the Treatment team in identifying my needs and in
                            developing this Treatment PIan which reflects my treatment objectives.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkClientGuardian_2" id="chkClientGuardian_2" className='add-only' value="ClientGuardian_2" /> I freely choose to receive and participate in the services outlined in this Treatment Plan.
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client Signature
                        </td>
                        <td className='small w-375'> Date
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Parent/Guardian Signature
                        </td>
                        <td className='small w-375'> Date
                        </td>
                    </tr>
                </table>
                <p>
                    The parent/guardian and clients over the age of 6 must sign the Treatment Plan
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>MHP/S Signature
                        </td>
                        <td className='small w-375'>LMHP Signature
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Discharge Planning Reviewed by LMHP </span>
                        </td>
                    </tr>
                    <tr>
                        <td> <input type='radio' id='rbDischargePlanning_Yes' name='rbDischargePlanning' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDischargePlanning_No' name='rbDischargePlanning' className='add-only' value='No' /> No &nbsp;&nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <p> <b>Select One:</b></p>
                <table>
                    <tr>
                        <td>  <input type='radio' id='rbSelectOne_DischargePlanRevised ' name='rbSelectOne' className='add-only' value='DischargePlanRevised ' /> Discharge Plan Revised  &nbsp;&nbsp;
                            <input type='radio' id='rbDischargePlanCurrentlyUnchanged_No' name='rbDischargePlanCurrentlyUnchanged' className='add-only' value='DischargePlanCurrentlyUnchanged' /> Discharge Plan Currently Unchanged &nbsp;&nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Rationale:</span>
                    <textarea id='txtRationaleSelectOne' name='txtRationaleSelectOne' className='add-only'></textarea>
                </p>
            </div>
        </form>

    )
}











